import React from 'react';
import * as Yup from 'yup';
import { Paper, withStyles } from '@material-ui/core';
import SKUPatternForm from './SKUPatternForm';
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from 'react-redux';
import * as actions from './store/skuPatternActions';
import History from '../../../History';
import { types } from './SKUPatternForm';

const styles = (theme) => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    },
});

const SKUPatternCreate = (props) => {
    const { permissions, activeCustomer, translations, onCreateSKUPattern, classes } = props;

    const handleSubmit = async (data) => {
        let objestToSend = { ...data };
        if (objestToSend['Key'] === '' || objestToSend['CustomerID'] === 'custom') {
            objestToSend['Key'] = null;
        }
        objestToSend['CustomerID'] === 'system'
            ? (objestToSend['CustomerID'] = null)
            : (objestToSend['CustomerID'] = activeCustomer);
        let result = await onCreateSKUPattern({ ...objestToSend, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        Name: '',
        Pattern: '',
        ProductType: '',
        CustomerID: types && types.length > 0 ? types[0].value : '',
        Key: '',
    };

    const maxLengthValidationText = 'Maximum 255 characters are allowed';
    const maxLengthValidationFn = (val) => (val ? val?.length <= 255 : true);

    let formSettings = {
        Validation: {
            Name: Yup.string().required('Required').test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            Pattern: Yup.string()
                .required('Required')
                .test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            ProductType: Yup.string().required('Required'),
            CustomerID: Yup.string().required('Required'),
            Key: Yup.string().required('Required'),
        },
        FormTitle: translations['create_sku_pattern'] || 'Create SKU pattern',
        ButtonSubmit:
            hasPermission(permissions, 'system_sku_pattern_create') || hasPermission(permissions, 'sku_pattern_create')
                ? {
                      Title: translations['save'] || 'SAVE',
                      Color: 'primary',
                  }
                : null,
    };
    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <SKUPatternForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                translations={translations}
                permissions={permissions}
                CustomerIDPreviousState={''}
            />
        </Paper>
    );
};
const mapStateToProps = (state) => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onCreateSKUPattern: (skuPattern) => dispatch(actions.createSKUPattern(skuPattern)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(SKUPatternCreate));
